import {
  alpha,
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  Paper,
  Popover,
  useTheme,
  Tooltip,
  Typography,
  styled
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import Link from '@mui/material/Link';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import CommentTwoToneIcon from '@mui/icons-material/CommentTwoTone';
import { useTranslation } from 'react-i18next';
import { formatDistance, subHours, subSeconds, subDays, parse } from 'date-fns';
import React from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Client, MessageDto } from '../../../DashboardApi/api';
import AddIcon from '@mui/icons-material/Add';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DoneIcon from '@mui/icons-material/Done';
import { REACT_APP_PORTAL_API_URL } from '../../../../KeyVariables';
import { ro } from 'date-fns/locale';
const IconButtonPrimary = styled(IconButton)(
  ({ theme }) => `
    display: flex;
    width: 58px;
    border-radius: ${theme.general.borderRadiusLg};
    height: 58px;
    justify-content: center;
    font-size: ${theme.typography.pxToRem(13)};
    padding: 0;
    position: relative;

    .MuiSvgIcon-root {
      transition: ${theme.transitions.create(['color'])};
      font-size: ${theme.typography.pxToRem(28)};
      color: ${theme.colors.alpha.trueWhite[50]};
    }

    &.active,
    &:hover {
      background-color: ${theme.colors.alpha.black[10]};

      .MuiSvgIcon-root {
        color: ${theme.colors.alpha.trueWhite[100]};
      }
    }
`
);

const AnimatedBadge = styled(Badge)(
  ({ theme }) => `
    
    .MuiBadge-badge {
        box-shadow: 0 0 0 2px ${theme.palette.background.paper};
        background-color: #44b700;
        color: #44b700;
        
        &::after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            animation: ripple 1.2s infinite ease-in-out;
            border: 1px solid currentColor;
            content: "";
        }
    }
`
);

const NotificationsBadge = styled(Badge)(
  ({ theme }) => `
    
    .MuiBadge-badge {
        background-color: ${alpha(theme.palette.warning.main, 0.9)};
        color: ${theme.palette.warning.contrastText};
        min-width: 18px; 
        height: 18px;
        padding: 0;

        &::after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            box-shadow: 0 0 0 1px ${alpha(theme.palette.warning.main, 0.3)};
            content: "";
        }
    }
`
);


function Notifications() {
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [tasks, setTasks] = useState<MessageDto[]>([]);
  const [tasksCount, setTasksCount] = useState<number>(0);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };
  const apiUrl = REACT_APP_PORTAL_API_URL;
  const client = new Client(apiUrl);
  useEffect(() => {
    client.gettaskscount().then(count => {
      if(count > 0) {
        setTasksCount(count)
        client.gettasks(page).then(data => {
          setTasks(data)
        })
      }
    });
  },[])
  const theme = useTheme();

  const iconMap = {
    New: <AddIcon/>,
    InProgress: <MoreHorizIcon/>,
    Done: <DoneIcon/>,
  };
  
  
  const colorsMap = {
    New: theme.colors.info.main,
    InProgress: theme.colors.warning.main,
    Done: theme.colors.success.main,
  };

  const addTasks = (newTasks: MessageDto[]) => {
    setTasks(prevTasks => {
      const updatedTasks = [...prevTasks];
      newTasks.forEach(newTask => {
        if (!prevTasks.some(task => task.id === newTask.id)) {
          updatedTasks.unshift(newTask);
        }
      });
      updatedTasks.sort((a, b) => a.id! - b.id!);
      return updatedTasks;
    });
  };


  const loadMore = (): void => {
    client.gettasks(page+1).then(data => {
      if(data.length > 0) {
        addTasks(data)
      }
    });
    setPage(page+1);
  };
  const { t }: { t: any } = useTranslation();

  return (
    <>
      <Tooltip arrow title={t('Tasks')}>
        <IconButtonPrimary color="primary" ref={ref} onClick={handleOpen}>
          <NotificationsBadge
            badgeContent={tasksCount}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            <AssignmentIcon />
          </NotificationsBadge>
        </IconButtonPrimary>
      </Tooltip>
      <Popover
        disableScrollLock
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          sx: {
            minWidth: 400,
            maxHeight: 600,
            overflowY: 'auto'
          }
        }}

      >
        <Box
          sx={{
            p: 2,
          }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography variant="h5">{t('Tasks')}</Typography>
        </Box>
        <Divider />
        <List
          sx={{
            p: 0
          }}
        >
          {
            tasks.length > 0 ?

            tasks.map(notif => (
                <>
                  <ListItem
                    sx={{
                      display: { xs: 'block', sm: 'flex' }
                    }}
                  >
                    <ListItemAvatar>
                    
                      <Avatar
                        sx={{
                          background: colorsMap[notif.type!]
                        }}
                      >
                        {iconMap[notif.type!]}

                      </Avatar>
                       
                    </ListItemAvatar>
                    <Box flex={1}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography
                          sx={{
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {notif.subject}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            textTransform: 'none'
                          }}
                        >
                          Deadline: {formatDistance(parse(notif.dateTime!, 'HH:mm dd.MM.yyyy', new Date()), new Date(), {
                            addSuffix: true,
                            locale:ro,
                          })}
                        </Typography>
                      </Box>
                      <Typography component="span"
                        variant="body2"
                        color="text.secondary">
                        {notif.body}                          
                      </Typography>
                        <Typography variant="caption" sx={{fontSize:10, ml: 1}}>
                        {"("+notif.component+")"}                          
                      </Typography>
                    </Box>
                    
                  </ListItem>
                  <Divider
                    variant="inset"
                    sx={{
                      my: 1
                    }}
                    component="li"
                  />
                </>
              )) : <>
                <Typography 
                sx={{p: 1}}
                >
                  There is no tasks to do!
                </Typography>

              </>
          }

        </List>
        <Divider />
        <Divider />
        <Box m={1}>
          <Button color="secondary" fullWidth onClick={loadMore}>
            {t('Load more')}
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default Notifications;
